import React, { SyntheticEvent } from 'react';
import { useHistory } from 'react-router-dom';

import { Checkbox } from '@trqk/components';

import { PATHS } from '../../../../constants';

interface EnvironmentCheckboxProps {
    currentEnvironment: string | null;
    setEnvironment(nextEnvironment: string): void;
    environment: string;
}

export const EnvironmentCheckbox = ({
    currentEnvironment,
    environment,
    setEnvironment,
}: EnvironmentCheckboxProps): JSX.Element => {
    const history = useHistory();

    return (
        <Checkbox
            checked={currentEnvironment === environment}
            onChange={(e: SyntheticEvent): void => {
                const target = e.target as HTMLInputElement;

                if (target.checked) {
                    setEnvironment(environment);

                    history.push(PATHS.SIGN_IN);
                }
            }}
            inputId={environment}
            label={environment}
            size="large"
        />
    );
};
